import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { loadRuntimeConfig, resolveCountryCode } from "./config.js";
import { CountryPicker } from "./screens/CountryPicker.js";
import { resolveNativeTvMode } from "./hooks/useTvMode.js";
import "./styles.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found in index.html");

const code = resolveCountryCode();

// No remembered / passed / baked-in country AND this build allows switching
// → show the picker. Selecting a country writes localStorage and reloads,
// after which resolveCountryCode() returns a value and the app boots.
if (!code) {
  createRoot(rootEl).render(
    <StrictMode>
      <CountryPicker />
    </StrictMode>
  );
} else {
  const config = loadRuntimeConfig(code);
  // TV mode must be known before the first render: layout, ads and focus
  // handling all branch on it. The native check takes a few milliseconds.
  void resolveNativeTvMode().then(() =>
    createRoot(rootEl).render(
      <StrictMode>
        <App config={config} />
      </StrictMode>
    )
  );
}
